var collapsible_list_component_rtlignore_default = {
  "ltr": "DGTsA",
  "rtl": "-Qm3L",
  "iconContainer": "JgO6l",
  "icon": "Bcta5",
  "isExpanded": "G77Uy",
  "listDimensions": "HXXgu"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
